var render = function render(){var _vm=this,_c=_vm._self._c;return _c('timeline-entry-item',{staticClass:"fade-in-half",scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"gl-px-4 gl-py-2 gl-text-subtle"},[_c('em',[_vm._v(_vm._s(_vm.note.body))])])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }